module.exports = __webpack_public_path__ + "img/glasses2.538aea0a.png";